/**
 * Hash routing, deliberately. A hash route never reaches the network, so a deep link works
 * from a cold start with no connectivity and needs no server rewrite rule.
 */
export type Route =
  | { name: 'round' }
  | { name: 'carts' }
  | { name: 'cart'; code: string }
  | { name: 'sites' }
  | { name: 'site'; code: string }
  | { name: 'labels' }
  | { name: 'reports' }
  | { name: 'round-detail'; id: string }
  | { name: 'settings' };

function parse(hash: string): Route {
  const path = hash.replace(/^#\/?/, '').split('?')[0] ?? '';
  const [head, arg] = path.split('/');
  switch (head) {
    case 'carts':
      return arg ? { name: 'cart', code: arg } : { name: 'carts' };
    case 'sites':
      return arg ? { name: 'site', code: arg } : { name: 'sites' };
    case 'rounds':
      return arg ? { name: 'round-detail', id: arg } : { name: 'reports' };
    case 'labels':
      return { name: 'labels' };
    case 'reports':
      return { name: 'reports' };
    case 'settings':
      return { name: 'settings' };
    default:
      return { name: 'round' };
  }
}

class Router {
  current = $state<Route>(parse(location.hash));
  constructor() {
    if (typeof window !== 'undefined') {
      window.addEventListener('hashchange', () => (this.current = parse(location.hash)));
    }
  }
  go(to: string) {
    location.hash = to.startsWith('#') ? to : `#/${to.replace(/^\//, '')}`;
  }
}

export const router = new Router();
